import { render, staticRenderFns } from "./VideoTranscript.vue?vue&type=template&id=58879cda&"
import script from "./VideoTranscript.vue?vue&type=script&lang=js&"
export * from "./VideoTranscript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports